import {
  useBalanceWithPoints,
  usePointsInputValidator,
} from "@apac/components/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";

interface UseReviewBalanceDisplayReturn {
  balanceToPay: string;
  isValidBalance: boolean;
  isConversionLoading: boolean;
}

export const useReviewBalanceDisplay = (): UseReviewBalanceDisplayReturn => {
  const { formatFiatCurrency } = useI18nContext();
  const { isValid: isValidBalance } = usePointsInputValidator();
  const { remainingBalance, isConversionLoading } = useBalanceWithPoints();
  const remainingBalanceToPay = formatFiatCurrency(remainingBalance);

  const balanceToPay = isValidBalance ? ` | ${remainingBalanceToPay}` : "";

  return {
    balanceToPay,
    isValidBalance,
    isConversionLoading,
  };
};
